<img alt="clear" src="assets/images/svgs/clear.svg" />
